<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="ok();"></div>
        <div class="bottomDrawer white_bg">
            <div class="body" style="margin-top: 10px; padding-bottom: 34px;">
                <div class="generalPagePaddingH" style="padding-top: 15px; padding-bottom: 8px;">
                    <label class="block sortItem clearfix" v-for="sortTypeItem in sortTypeList" :key="sortTypeItem.id">
                        <span class="fl">{{sortTypeItem.title}}</span>
                        <input class="fr modernCheckbox orangeCircleTickCheckbox" type="radio"
                           name="sort" :value="sortTypeItem.id" v-model="selectedSortType"/>
                    </label>
                </div>
                <div class="generalPagePaddingH" style="padding-top: 6px; padding-bottom: 6px;">
                    <button class="button block okButton" @click="ok()">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../../part/drawerPart';


const config = {
    apiConfig : {
        list : {
            url : "",
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "jobSortSelectorDrawer",
    extends : drawerPart,
    data() {
        return {
            apiConfig : config.apiConfig,
            sortTypeList : [{
                id : 'DEFAULT',
                title : '推荐'
            },{
                id : 'SALARY',
                title : '薪资从高到低'
            }],
            selectedSortType : null
        }
    },
    methods : {
        ok() {
            this.$emit('change', {
                sortType : this.selectedSortType
            });
            this.close();
        }
    },
    mounted() {
        // this.selectedSortType = this.sortTypeList[0];
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.sortItem {
    margin-bottom: 18px;
}
.okButton {
    height: 36px;
    line-height: 36px;
    background: #FFA724;
    border-radius: 24px;
    padding: 0;
    color: white;
}

</style>
